import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import { logout } from "../../../actions/session";
import PERMISSION from "../../../model/permissions";
import M from "../../../strings";
import { Screen } from "../../components/layout";
import { ACTION_TYPES } from "../../components/mobile/actions";
import MobileLayout from "../../components/mobile/layout";
import Secure from "../../components/secure";
import * as ui from "../../utils/ui";
import { mobileConfirm } from "../../../plugins";
import { connect } from "../../utils/aj";
import { getDefaultState, SurveysStore } from "../../../stores/surveys";
import { createSurvey, getOpenSurveys, getUserSurveys } from "../../../actions/surveys";
import { SURVEY_STATUS } from "../../../model/vars";
import Carousel from "../../components/mobile/carousel";
import { MaterialIcon } from "../../components/materialIcon";
import * as _query from "../../../framework/query";
import { format, optional } from "../../../utils/lang";
import { isNotEmpty } from "../../../framework/utils";
import { SurveyCard, SurveySummary } from "../../components/mobile/surveys";
import { hideDialog, showDialog, updateDialog } from "../../../actions/dialog";
import Searchbar from "../../components/mobile/searchbar";
import { freeEntities, loadEntities, updateQuery } from "../../../actions/entities";
import { connectDiscriminated } from "../../../utils/aj-react";
import { EntitiesStore } from "../../../stores/entities";
import * as RetailersUtils from "../../utils/retailers";

export default class MobileHome extends Screen {

    getRightActions() {
        return [
            {
                id: "stores",
                type: ACTION_TYPES.ICON,
                icon: "storefront",
                rounded: true,
                onClick: () => ui.navigate("/app/stores"),
            },
            {
                id: "more",
                type: ACTION_TYPES.DROPDOWN,
                items: [
                    {
                        id: "backoffice",
                        icon: "settings",
                        title: M("backoffice"),
                        onClick: () => {
                            ui.navigate("/entities/store?showSidebar=false");
                        },
                        permissions: [
                            PERMISSION.ADMIN_SUPERUSER,  
                        ],
                    },
                    {
                        id: "logout",
                        icon: "logout",
                        title: M("logout"),
                        onClick: () => {
                            mobileConfirm("Sei sicuro di voler uscire?")
                                .then(logout);
                        },
                    },
                ],
            },
        ]
    }

    render() {
        const rightActions = this.getRightActions();

        return (
            <Secure>
                <MobileLayout
                    showLogo={true}
                    rightActions={rightActions}
                >
                    <OngoingSurveys/>
                    <UserSurveys/>
                </MobileLayout>
            </Secure>
        )
    }
}

class OngoingSurveys extends React.Component {
    constructor(props) {
        super(props);
        const query = _query.create({
            rowsPerPage: 5,
        });
        connect(
                this,
                SurveysStore,
                _.extend(
                        {},
                        getDefaultState(),
                        {
                            query: query,
                        }
                    )
            );

        query.on("change", () => this.getData());
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const query = this.state.query;
        getOpenSurveys({
            query: query,
        })
    }

    createSurvey(){
        showDialog({
            mobile: true,
            title: M("newSurvey"),
            getContent: () => <CreateSurveyDialog/>,
        })
    }

    viewSurvey(surveySummary) {
        ui.navigate("/app/survey/" + surveySummary.survey.id);
    }

    viewAll() {
        ui.navigate("/app/surveys/ongoing");
    }

    getItems() {
        const rows = optional(() => this.state.openSurveys.rows, []),
            items = _.map(rows, row => {
                return (
                    <SurveyCard
                        key={"ongoing-survey-" + row.id}
                        useProgressBar={true}
                        surveySummary={row}
                        onClick={this.viewSurvey.bind(this)}
                    />
                )
            })
        
        return items;
    }

    render() {
        const items = this.getItems(),
            linkLabel = isNotEmpty(items) ? format(M("viewAllN"), items.length) : undefined;

        items.unshift((
            <div
                className="survey-summary survey-summary--card survey-summary--create"
                onClick={this.createSurvey.bind(this)}
            >
                <span
                    className="survey-summary__line-spacer"
                />
                <MaterialIcon
                    icon="add"
                />
                <span>
                    {M("newSurvey")}
                </span>
            </div>
        ));

        return (
            <Carousel
                title={M("ongoingSurveys")}
                linkLabel={linkLabel}
                onLinkClick={this.viewAll.bind(this)}
                items={items}
            />
        )
    }
}

class UserSurveys extends React.Component {
    constructor(props) {
        super(props);
        const query = _query.create({
            rowsPerPage: 100,
        });
        connect(
                this,
                SurveysStore,
                _.extend(
                        {},
                        getDefaultState(),
                        {
                            query: query,
                        }
                    )
            );

        query.on("change", () => this.getData());
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const query = this.state.query;
        getUserSurveys({
            query: query,
        })
    }

    viewSurvey(surveySummary) {
        ui.navigate("/app/survey/" + surveySummary.survey.id);
    }

    render() {
        const items = optional(() => this.state.userSurveys.rows, []);
            
        return(
            <div
                className="user-surveys"
            >
                <div
                    className="user-surveys__header"
                >
                    <span>
                        {M("userSurveysTitle")}
                    </span>
                    <span>
                        {items.length}
                    </span>
                </div>
                {isNotEmpty(items) ? (<div
                    className="user-surveys__items"
                >
                    {_.map(items, (item, index) => {
                        const key = "user-survey-item-" + index;

                        return (<div
                                key={key}
                                className="user-survey__item"
                            >
                                <SurveySummary
                                    surveySummary={item}
                                    onClick={this.viewSurvey.bind(this)}
                                />
                            </div>)
                    })}
                </div>) : (
                    <div className="p-5 text-center">
                        {M("noSurveys")}
                    </div>
                )}
            </div>
        )
    }
}

class CreateSurveyDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            selected: {},
        }
    }

    componentDidMount() {
        this.updateDialogActions();
    }

    getMaxSteps() {
        return 2
    }

    prevStep() {
        const currentStep = this.state.currentStep;
        if (currentStep > 1) {
            this.setState(
                {currentStep: currentStep - 1},
                this.updateDialogActions.bind(this)
            )
        }
    }

    nextStep() {
        const currentStep = this.state.currentStep;

        if (!this.canGoAhead()) {
            return false;
        }

        if (currentStep < this.getMaxSteps()) {
            this.setState(
                {currentStep: currentStep + 1},
                this.updateDialogActions.bind(this)
            )
        }
    }

    setStep(step) {
        const currentStep = this.state.currentStep;

        if (currentStep < step && !this.canGoAhead()) {
            return (false);
        }

        if (step >= 1 && step <= this.getMaxSteps()) {
            this.setState(
                {currentStep: step},
                this.updateDialogActions.bind(this)
            )
        }
    }

    save() {
        if (!this.canGoAhead()) {
            return false;
        }
        const selected = optional(this.state.selected, {}),
            data = {
                surveyTemplateId: selected.surveyTemplate.id,
                storeId: selected.store.id,
            }

        createSurvey(data)
            .then(() => {
                location.reload();
            })
            .finally(hideDialog)
    }

    canGoAhead() {
        const selected = optional(this.state.selected, {}),
            currentStep = this.state.currentStep,
            required = [];

        switch(currentStep) {
            case 2:
                required.push("store");
            case 1:
                required.push("surveyTemplate");
        }

        return _.all(required, (key) => selected[key] !== undefined);
    }

    updateDialogActions() {
        const {leftHeaderActions, rightHeaderActions} = this.getDialogActions();

        updateDialog({
            leftHeaderActions: leftHeaderActions,
            rightHeaderActions: rightHeaderActions,
        });
    }

    getDialogActions() {
        const currentStep = this.state.currentStep,
            leftHeaderActions = [],
            rightHeaderActions = [];

        switch(currentStep) {
            case 1:
                leftHeaderActions.push(
                        {
                            id: "close-mobile",
                            type: ACTION_TYPES.ICON,
                            icon: "close",
                            className: "hidden-sm-up",
                            onClick: hideDialog,
                        },
                        {
                            id: "close-tabled",
                            type: ACTION_TYPES.BUTTON,
                            text: M("cancel"),
                            className: "btn-transparent-secondary hidden-xs-down",
                            onClick: hideDialog,
                        },
                    );
                rightHeaderActions.push(
                        {
                            id: "forward",
                            type: ACTION_TYPES.BUTTON,
                            text: M("forward"),
                            className: "btn-transparent-primary",
                            onClick: this.nextStep.bind(this),
                            disabled: !this.canGoAhead(),
                        }
                    );
                break;
            case 2:
                leftHeaderActions.push(
                        {
                            id: "back-mobile",
                            type: ACTION_TYPES.ICON,
                            icon: "arrow_back",
                            className: "hidden-sm-up",
                            onClick: this.prevStep.bind(this),
                        },
                        {
                            id: "back-tablet",
                            type: ACTION_TYPES.BUTTON,
                            text: M("back"),
                            className: "btn-transparent-secondary hidden-xs-down",
                            onClick: this.prevStep.bind(this),
                        }
                    );
                rightHeaderActions.push(
                    {
                        id: "save",
                        type: ACTION_TYPES.BUTTON,
                        text: M("save"),
                        className: "btn-transparent-primary",
                        onClick: this.save.bind(this),
                        disabled: !this.canGoAhead(),
                    }
                )
                break;
        }
        
        return {
            leftHeaderActions: leftHeaderActions,
            rightHeaderActions: rightHeaderActions,
        }
    }

    getEntity() {
        const currentStep = this.state.currentStep;
        
        switch(currentStep) {
            case 1:
                return "surveyTemplate";
            case 2:
                return "store";
            default:
                return undefined;
        }
    }

    onSelectItem(item) {
        const entity = this.getEntity(),
            selected = _.extend({}, this.state.selected || {});

        selected[entity] = item;

        this.setState({selected: selected},this.updateDialogActions.bind(this));
    }

    render() {
        const maxSteps = this.getMaxSteps(),
            currentStep = this.state.currentStep,
            entity = this.getEntity(),
            selectedItem = optional(() => this.state.selected[entity]);

        return (
            <>
                <CreateSurveyDialogPagination
                    paginationSteps={maxSteps}
                    currentStep={currentStep}
                    onStepClick={this.setStep.bind(this)}
                />
                <CreateSurveyDialogList
                    key={"new-survey-list-" + currentStep}
                    wizardStep={currentStep}
                    entity={this.getEntity()}
                    selectedItem={selectedItem}
                    onSelectItem={this.onSelectItem.bind(this)}
                />
            </>
        )
    }
}

class CreateSurveyDialogPagination extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement("div");
    }

    getModalContentHeader() {
        const el = document.getElementsByClassName("modal-content-header");
        return isNotEmpty(el) ? el[0] : undefined;
    }

    componentDidMount() {
        const headerElement = this.getModalContentHeader();
        headerElement && headerElement.insertBefore(this.el, headerElement.firstChild);
    }

    componentWillUnmount() {
        const headerElement = this.getModalContentHeader();
        headerElement && headerElement.removeChild(this.el);
    }

    onStepClick(step) {
        if (this.props.onStepClick && _.isFunction(this.props.onStepClick)) {
            this.props.onStepClick(step);
        }
    }

    render() {
        const paginationSteps = optional(this.props.paginationSteps, 1),
            currentStep = optional(this.props.currentStep, 1),
            paginationItems = [];

        for (let i = 1; i <= paginationSteps; i++) {
            const isActive = i === currentStep;
            paginationItems.push(
                <li
                    key={"pagination-item-" + i}
                    className={"page-item" + (isActive ? " active" : "")}
                >
                    <a
                        className="page-link"
                        onClick={() => this.onStepClick(i)}
                    >
                        {i}
                    </a>
                </li>
            )
        }

        const content = (<div
                className="new-survey-wizard__pagination"
            >
                <ul
                    className="pagination pagination--wizard"
                >
                    {paginationItems}
                </ul>
            </div>)

        return ReactDOM.createPortal(content, this.el);
    }
}

class CreateSurveyDialogList extends React.Component {
    constructor(props) {
        super(props);
        
        const entity = this.getEntity(),
            discriminator = "create-survey_dialog_list_" + entity,
            query = _query.create({rowsPerPage: 100});

        query.on("change", () => {
            updateQuery({discriminator: this.discriminator, query: this.state.query});
            this.getData();
        })

        this.discriminator = discriminator;
        this.query = query;

        connectDiscriminated(this.discriminator, this, EntitiesStore, {result: null, query: query});
    }

    componentDidMount() {
        this.getData();
        updateDialog({
            subtitle: this.getSubtitle(),
        })
    }

    componentWillUnmount() {
        freeEntities({discriminator: this.discriminator})
    }

    onItemClick(item) {
        if (this.props.onSelectItem && _.isFunction(this.props.onSelectItem)) {
            this.props.onSelectItem(item);
        }
    }

    getData() {
        loadEntities({discriminator: this.discriminator, entity: this.getEntity(), query: this.state.query});
    }

    getEntity() {
        return this.props.entity;
    }

    getSubtitle() {
        const currentStep = this.props.wizardStep;
        switch (currentStep) {
            case 1:
                return M("pickTemplateMessage")
            case 2:
                return M("pickStoreMessage")
        }
    }

    getItems() {
        const currentStep = this.props.wizardStep,
            selectedItem = optional(this.props.selectedItem, {}),
            rows = optional(() => this.state.result.rows, []);

        let items;

            //items = optional(() => this.state.result.rows, []);
        //let formatter = () => "N/A";

        switch(currentStep) {
            case 1:
                items = _.map(rows, item => {
                    const active = selectedItem.id === item.id;
                    return (<div
                            key={item.id}
                            className={"new-survey-wizard__item" + (active ? " active" : "")}
                            onClick={() => this.onItemClick(item)}
                        >
                            <div
                                    className="new-survey-wizard__item-title"
                                >
                                    {item.description}
                            </div>
                        </div>)
                })
                break;
            case 2:
                items = _.map(rows, item => {
                    const active = selectedItem.id === item.id,
                        currentSurvey = item.currentSurvey,
                        surveyOpen = optional(() => currentSurvey.status === SURVEY_STATUS.OPEN, false);

                    let statusText = M("noSurveys"),
                        className="new-survey-wizard__item";

                    if (active) {
                        className += " active";
                    }

                    if (surveyOpen) {
                        className += " disabled";
                    }

                    if (isNotEmpty(currentSurvey)) {
                        statusText = surveyOpen
                            ? M("ongoingSurvey") 
                            : format(
                                M("lastSurveyDate"),
                                new Date(currentSurvey.lastEditTime).toLocaleDateString()
                            )
                    }

                    return (<div
                            key={item.id}
                            className={className}
                            onClick={() => !surveyOpen && this.onItemClick(item)}
                        >
                            <div
                                className="new-survey-wizard__item-title"
                            >
                                {RetailersUtils.getStoreDescription(item)}
                            </div>
                            <div
                                className="new-survey-wizard__item-subtitle"
                            >
                                {item.address}
                            </div>
                            <div
                                className="new-survey-wizard__item-text"
                            >
                                {statusText}
                            </div>
                        </div>)
                })
                break;
        }

        return items;
    }

    onKeywordChange(keyword) {
        const query = this.state.query;
        query.setKeyword(keyword);
    }

    render() {
        const items = this.getItems();

        return(
            <>
                <Searchbar
                    className="new-survey-wizard__searchbar"
                    onChange={this.onKeywordChange.bind(this)}
                />
                <div
                    className="new-survey-wizard__items"
                >
                    {items}
                </div>
            </>
        )
    }
}